import { Button } from '@mui/material';
import Modal from 'react-modal';
import "../styles/user-exists-modal.scss";

export const UserExistsModal = ({ isOpen, phone, onClose }) => {

if (!isOpen) return null;

return (
    <Modal
        className="modal-content-custom"
        overlayClassName="modal-overlay-custom"
        isOpen={isOpen}>
        <div className='close-btn'>
            <Button variant="contained" onClick={onClose}>&times;</Button>
        </div>
        <h2 className='header'>Пользователь существует</h2>
        
        <p> Пользователь с таким номером телефона {phone} уже существует. Хотите восстановить пароль? </p>

        <Button variant="contained" className='link-btn' onClick={() => window.location.href = `/passwordRecovery?phone=${phone}`}>Восстановить пароль</Button>

    </Modal>
    )
}